import { render, staticRenderFns } from "./photoCutOne.vue?vue&type=template&id=3c3fc1f6&"
import script from "./photoCutOne.vue?vue&type=script&lang=js&"
export * from "./photoCutOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports